module.exports = __webpack_public_path__ + "static/media/STEAM.c121ac14.svg";